import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import IkelMt from "./pages/IkelMt";
import Furniture from "./pages/Furniture";
import Logistics from "./pages/Logistics";
import Quote from "./pages/Quote";

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ikel-mt" element={<IkelMt />} />
              <Route path="/furniture" element={<Furniture />} />
              <Route path="/logistics" element={<Logistics />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}
